import { getReviewCodiGoods } from './getReviewCodiGoods';
import { postReviewLike } from './postReviewLike';
import { deleteReviewLike } from './deleteReviewLike';

export const reviewsService = {
  getReviewCodiGoods,
  postReviewLike,
  deleteReviewLike,
};